import type { SectionLocale } from '../types'

export const HEADER_LOCALE: SectionLocale = [
  [
    'header_search',
    {
      ru: 'Найти коллегу',
      en: 'Find an employee',
    },
  ],
  [
    'header_dropdown-profile',
    {
      ru: 'Профиль',
      en: 'Profile',
    },
  ],
  [
    'header_dropdown-language',
    {
      ru: 'Язык',
      en: 'Language',
    },
  ],
]
